/*******************************************************************************
 * Project：WDCK
 * Summary:
 *　　 Forgot password function
 * History：
 *      AnBD            2021/08/31    Create new
******************************************************************************/
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { SrcExamForgotPasssService } from '../src-pw-forgot/src-pw-forgot.service';
import { LoadingService } from '../../../../layout/loading/loading.service';
import { DialogModalService } from '../../../../shared/dialog-modal/dialog-modal.service';
import { Utility } from '../../../../shared/utility/utility';
import { UserLoginInfoDto } from '../../../../models/UserLoginInfoDto';
import { finalize } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QueryParams } from 'src/app/shared/constant';
@Component({
  selector: 'app-src-pw-forgot',
  templateUrl: './src-pw-forgot.component.html',
  styleUrls: ['./src-pw-forgot.component.scss']
})
export class SrcPwForgotComponent implements OnInit {
  maillAdress: string;
  resetData: any;
  messErrMail: string;
  isErrMail = false;
  constructor(
    private auth: SrcExamForgotPasssService,
    private loadingSrv: LoadingService,
    private dialogModalService: DialogModalService,
    public translate: TranslateService,
    private router: Router,
    private model: NgbModal,
    public util: Utility,
    private routeActived: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.util.resetZoomBrowser();
    if (!this.util.isNullOrEmpty(sessionStorage.Time10Err)) {
      this.dialogModalService.openErrorModal(this.translate.instant('MESS_ERR_LOGIN_FAILED_10TIMES'));
    }
    sessionStorage.removeItem('Time10Err');
  }
  inputValidate() {
    if (this.util.isNullOrEmpty(this.maillAdress)) {
      this.isErrMail = true;
      this.messErrMail = this.translate.instant('MESS_CMN_ERR_MISS_INPUT_REQUIRED')
        .replace('{0}', this.translate.instant('STR_EMAIL_ADDRESS'));
      return true;
    }
    else {
      this.isErrMail = false;
    }
    return false;
  }
  Reset() {
    if (this.inputValidate()) {
      return;
    }
    const LG = localStorage.getItem('language');
    let language = '';
    if (LG === 'vi') {
      language = 'VN';
    }
    else if (LG === 'en') {
      language = 'EN';
    }
    else {
      language = 'JP';
    }
    const htOrgCode = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
    const sLoginData = new UserLoginInfoDto();
    sLoginData.MailAdress = this.maillAdress;
    sLoginData.Language = language;
    sLoginData.HTOrgCode = htOrgCode;
    this.loadingSrv.setDisplay(true);
    this.auth.Fogot(sLoginData).pipe(
      finalize(() => {
        this.loadingSrv.setDisplay(false);
      })
    ).subscribe(data => this.resetData = data, (error) => {
      this.loadingSrv.setDisplay(false);
    }, () => {
      this.loadingSrv.setDisplay(false);
      if (this.resetData === true) {
        this.messErrMail = '';
        this.isErrMail = false;
        this.dialogModalService.openInfoModal(this.translate.instant('MESS_INF_MAIL_WITHLINK_ALREADY_SENT'));
        //  redirect trang toppage
      }
      else {
        this.messErrMail = 'MESS_PLS_INPUT_REGISTERED_MAIL';
        this.isErrMail = true;
      }
    });
  }
  BackLogin() {
    const htOrgCode = this.routeActived.snapshot.queryParams[QueryParams.HtOrgCode];
    this.router.navigate(['login'], {
      queryParams: {
        htorgcode: htOrgCode
      }
    });
  }
  removeErr() {
    this.isErrMail = false;
  }
  toLowerCase() {
    this.maillAdress = this.maillAdress.toLocaleLowerCase();
  }
}
